var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[(_vm.CompanyLogo)?_c('img',{staticClass:"img-fluid for-light1",staticStyle:{"max-width":"85%"},attrs:{"src":require("@/assets/images/logo.png")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }